(ns hypnos.dme.routes
  "Hypnos DME routes."
  (:require [bidi.bidi :as bidi]
            [pushy.core :as pushy]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:private true :const true} referral-code-regex
  #"[0-9a-zA-Z]{4}[0-9a-zA-Z]{4}[0-9a-zA-Z]{4}")

(def ^{:private true :const true} uuid-regex
  #"(?i)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}")

(def ^{:const true :private true} routes
  ["/" {;; main panels
        ""                                                 :dashboard-panel
        "dashboard"                                        :dashboard-panel
        "patients"                                         :patients-panel
        ["patient/" [uuid-regex :patient-id]]              :patient-panel
        "patient"                                          :patient-panel
        ["referral/" [referral-code-regex :referral-code]] :referral-panel
        "referral"                                         :referral-panel}])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- parse-url
  []
  (fn [url]
    (bidi/match-route routes url)))

(defn- dispatch-route
  [matched-route]
  (let [route        (name (:handler matched-route))
        route-params (:route-params matched-route)
        panel-name   (keyword route)]
    (rf/dispatch [:dme/set-active-panel {:name   panel-name
                                         :params route-params}])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn path-for
  [& args]
  (apply bidi/path-for routes args))

(defn app-routes []
  (pushy/start! (pushy/pushy dispatch-route (parse-url))))
